import { Box } from "@chakra-ui/react"
import { useBrandedTranslation } from "../../../../common/hooks/useBrandedTranslation"
import { TileProduct, TileSparePart } from "../../../../common/types/global"
import { CarouselTiles } from "../../../shared/CarouselTiles"
import { SectionTitle } from "../../../shared/SectionTitle"

type Props = {
  products: (TileProduct & TileSparePart)[]
}

const CombineWithProducts = ({ products }: Props) => {
  const { t } = useBrandedTranslation()

  return (
    products &&
    !!products.length && (
      <Box>
        <SectionTitle title={t("pdp-nav-combineWith")} mb="6" />
        <CarouselTiles items={products} />
      </Box>
    )
  )
}

export default CombineWithProducts
